import { gql } from '@apollo/client';

export const ESTIMATION_FACTORS = gql`
  query EstimationFactors($month_year: String!) {
    estimationFactors(month_year: $month_year) {
      totalCount
      data {
        id
        energy_source
        month_year
        region
        estimate_factor
        prev_month_net_units
        current_month_net_units
      }
    }
  }
`;
